import React, { useEffect, useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Form, Button, Modal, Row, Col, Table } from 'react-bootstrap'
import {
    editCategory,
    getCategories,
    saveCategorie
} from '../utils'
import {
    setCategories,
    setCategorie
} from './actions'

import { mapTest } from '../map.test'

import Pagination from '@inspinia-react/pagination'
import { notification } from 'antd'
import { checkIfBranchExists } from '../../../../utils'


function Categories(props) {
    checkIfBranchExists()
    const [show, modalState] = useState(false)
    const [name, setName] = useState('')

    function save() {
        const { categories } = props;

        for (let x = 0; x < categories.length; x++) {
            const category = categories[x];
            if (name.toLowerCase() === category.name.toLowerCase()) {
                console.log(category)
                props.setCategorie(category);
                modalState(false)
                notification.open({
                    type: 'info',
                    message: "Unidade já cadastrada",
                    key: "4311"
                })
                return;
            }
        }
        saveCategorie(name, category => {
            resetModal()
            getCategories(categories => {
                props.setCategories(categories)
                props.setCategorie(category)
            })
        },
            () => modalState(false))
    }

    useEffect(() => {
        setTimeout(() => {
            getCategories(categories => props.setCategories(categories))
        }, 200)
    }, [])

    function resetModal() {
        setName('')
        modalState(false)
    }

    useEffect(() => {
        if (!props.category && props.categories.length) {
            props.setCategorie(props.categories[0])
        }
    }, [props.category, props.categories])

    return <React.Fragment>
        <p className="lead mb-2">Categoria</p>
        <Form.Group>
            <Row>
                <Col md="10" className="m-0 p-0">
                    <Form.Control
                        as="select"
                        id={mapTest.createProduct.category.select}
                        onChange={e => {
                            const cat = props.categories[e.currentTarget.selectedIndex]
                            props.setCategorie(cat)
                        }}
                    >
                        {
                            props.categories.map(cat => <option
                                selected={cat.id === props.category.id}
                                value={cat.id}
                                key={cat.id}>
                                {cat.name}
                            </option>)
                        }
                    </Form.Control>
                </Col>
                <Col md="2" className="m-0 p-0">
                    <Button
                        block
                        onClick={() => modalState(true)}
                        id={mapTest.createProduct.category.buttonCreate}
                    >
                        <i className="fas fa-plus"></i>
                    </Button>
                </Col>
            </Row>
        </Form.Group>
        <Modal show={show}>
            <Modal.Header>
                <h2>
                    Criar nova categoria
                </h2>
            </Modal.Header>
            <Modal.Body>
                <Form.Label>Nome</Form.Label>
                <Form.Control
                    onChange={e => setName(e.target.value)}
                    value={name}
                    id={mapTest.createProduct.category.inputName}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="danger"
                    onClick={resetModal}
                    id={mapTest.createProduct.category.buttonClose}
                >
                    Fechar
                </Button>
                <Button
                    onClick={save}
                    id={mapTest.createProduct.category.buttonSave}
                >
                    Salvar
                </Button>
            </Modal.Footer>

        </Modal>
    </React.Fragment>
}

export function List(props) {
    
    const [categories, setCategories] = React.useState([])
    const [selected, setSelected] = React.useState({})
    const [showModal, setShowModal] = React.useState(false)

    const [newName, setNewName] = React.useState("")

    function onEdit() {
        const payload = resp => {
            getCategories(setCategories)
            setShowModal(false)

            notification.open({
                message: "Categoria atualizada com sucesso!",
                type: "success",
                key: "84",
                duration: 2
            })
            setTimeout(() => {
                window.location.reload()
            }, 2000);
        }
        const errPayload = resp => {
            setShowModal(false)
        }
        editCategory(selected.id, { name: newName }, payload, errPayload)
    }

    React.useEffect(() => {
        checkIfBranchExists()
        getCategories(setCategories)
    }, 350)

    return <div>
        <h1 className='text-center'>Categorias</h1>
        <Pagination
            labels={["Nome", "Ações"]}
            items={categories}
            dataComponent={cat => [
                <td>{cat.name}</td>,
                <td>
                    <button
                        className='fas fa-edit btn btn-sm btn-primary'
                        onClick={() => {
                            setNewName(cat.name)
                            setSelected(cat)
                            setShowModal(true)
                        }}
                    />
                </td>
            ]}
        />
        <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header>
                Editar Categoria
            </Modal.Header>
            <Modal.Body>
                Novo nome
                <input
                    className='form-control'
                    value={newName}
                    onChange={e => setNewName(e.target.value)}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='danger' onClick={() => setShowModal(false)}>Voltar</Button>
                <Button onClick={onEdit}>Editar</Button>
            </Modal.Footer>
        </Modal>
    </div>
}
const mapStateToProps = state => ({
    categories: state.categories,
    category: state.category
})
const mapDispatchToProps = dispatch => bindActionCreators({
    setCategories,
    setCategorie
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Categories)
connect(mapStateToProps, null)(List)


// WEBPACK FOOTER //
// ./src/components/pages/products/base/categories.jsx